// extracted by mini-css-extract-plugin
module.exports = {"arrow-btn-box":"aU","arrowBtnBox":"aU","arrow-btn-wrap-box":"aV","arrowBtnWrapBox":"aV","arrow-btn-text":"aW","arrowBtnText":"aW","arrow-btn-arrow":"aX","arrowBtnArrow":"aX"};